<section class="aside-subnav" [ngClass]="{'aside-subnav--full-page': showFullPage}">
  <ng-container *ngIf="brands; else loading">
    <ng-container *ngIf="brands.length">
      <div class="search">
        <mat-form-field>
          <input matInput placeholder="Search" type="search" [(ngModel)]="searchBrand">
          <mat-icon matSuffix>search</mat-icon>
        </mat-form-field>
      </div>

      <mat-nav-list
        [ngClass]="{'mat-nav-list--button': user._rolesName === 'admin' || user._privileges.canCreateBrand}">
        <div *ngFor="let brand of brands | filter:searchBrand:['name','shortDesc']">

          <a mat-list-item
             *ngIf="brand.access || user._rolesName === 'admin' || user._privileges.canCreateBrand"
             routerLinkActive="active"
             routerLink="/brands/{{ brand.uid }}">
            <div matLine>
              {{ brand.name }}
            </div>
            <div matLine *ngIf="brand.shortDesc">
              <small>{{ brand.shortDesc }}</small>
            </div>
            <div matLine *ngIf="brand.client">
              <small>{{ brand.client.name }}</small>
            </div>
          </a>

        </div>
      </mat-nav-list>

    </ng-container>
  </ng-container>

  <ng-template #loading>
    <div class="spinner">
      <div class="bounce1"></div>
      <div class="bounce2"></div>
      <div class="bounce3"></div>
    </div>
  </ng-template>

  <div class="container-btm"
       *ngIf="user._rolesName === 'admin' || user._privileges.canCreateBrand">
    <a routerLink="/brands/brand-add" mat-stroked-button color="primary">Add social brand</a>
  </div>
</section>

<main class="help-margin-left-180px">
  <div class="container">
    <div class="row">
      <div class="col">
        <header class="page-header">
          <h1 [innerHTML]="title" *ngIf="title"></h1>
          <nav mat-tab-nav-bar>
            <a mat-tab-link
               *ngFor="let link of navLinks"
               [routerLink]="link.path"
               routerLinkActive #rla="routerLinkActive"
               [active]="rla.isActive">
              {{link.label}}
            </a>
          </nav>
        </header>

        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
</main>
